import {CompanyInfo} from '@/common/Enum/SettingsType.enum';
import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {environment} from 'environments/environment';

@Injectable({
    providedIn: 'root'
})
export class CompanyService {
    constructor(private httpClient: HttpClient) {}
    private apiUrl = environment.apiUrl;

    addCompanyInformation(companyInformation: CompanyInfo) {
        return this.httpClient.post(
            `${this.apiUrl}/User/InsertCompanyInformation`,
            companyInformation
        );
    }

    updateCompanyInformation(companyInformation: CompanyInfo) {
        return this.httpClient.post(
            `${this.apiUrl}/User/UpdateCompanyInformation`,
            companyInformation
        );
    }

    getCompanyInformation(userId: number) {
        return this.httpClient.get<CompanyInfo>(
            `${this.apiUrl}/User/GetCompanyInformation?userId=${userId}`
        );
    }
}
